export default __webpack_public_path__ + "images/home-audio-install-service.jpg";